var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Plus icon"),React.createElement("desc",{"key":1},"Plus icon"),React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(1 1)","key":2},React.createElement("path",{"d":"M16.571 10.143v11.71M22.429 16h-11.71"}))]);
}

IconPlus.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","role":"img"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
